import { menuTree } from "@/api/menu";
let allMenuPath = [];
let btnPermissions = [];
let menuPermissions = [];
const permission = {
  state: {
    menuList:[],
    menuPerssions: [],
    btnPermissions: [],
    allMenuPath: [],
    menuFlag: false, //菜单接口是否查询过
  },
  mutations: {
    SET_MENUS: (state, menus) => {
      state.menuList = menus || [];
    },
    SET_MENU_PERMISSIONS: (state, permissions) => {
      state.menuPerssions = permissions || [];
    },
    SET_BUTTON_PERMISSIONS: (state, permissions) => {
      state.btnPermissions = permissions || [];
    },
    SET_ALL_PATH: (state, path) => {
      state.allMenuPath = path || [];
    },
    SET_MENU_FLAG: (state, flag) => {
      state.menuFlag = flag;
    },
  },
  actions: {
    GetMenu({ commit }) {
      return new Promise((resolve, reject) => {
        menuTree()
          .then((res) => {
            allMenuPath = [];
            btnPermissions = [];
            menuPermissions = [];
            if (res.code === "00000") {
              let data = res.data;
              commit("SET_MENUS", res.data);
              //按钮权限
              let btnData = getBtnPermissions(data) || [];
              commit("SET_BUTTON_PERMISSIONS", btnData);
              //菜单权限
              commit("SET_MENU_PERMISSIONS", getMenuPermissions(data));
              commit("SET_ALL_PATH", allMenuPath);
              commit("SET_MENU_FLAG", true);
              resolve(data);
            } else {
              commit("SET_MENU_FLAG", true);
              resolve(res);
            }
          })
          .catch((error) => {
            commit("SET_MENU_FLAG", true);
            reject(error);
          });
      });
    },
  },
};
/**递归获取菜单权限数据 */
function getMenuPermissions(list) {
  setMenuList(list);
  return menuPermissions;
}

function setMenuList(list) {
  list.forEach((el) => {
    if (el.type == 1 && el.showFlag == 1) {
      menuPermissions.push(el.permissionCode);
      allMenuPath.push(el.routeAddress);
      menuPermissions = [...new Set(menuPermissions)];
    }
    if (el.childList) {
      getMenuPermissions(el.childList);
    }
  });
}
/**递归获取按钮及页签权限数据 */
function getBtnPermissions(list) {
  setBtnList(list);
  return btnPermissions;
}
function setBtnList(list) {
  list.forEach((el) => {
    if ((el.type == 2 || el.type == 3) && el.showFlag == 1) {
      btnPermissions.push(el.permissionCode);
      btnPermissions = [...new Set(btnPermissions)];
    }
    if (el.childList) {
      getBtnPermissions(el.childList);
    }
  });
}

export default permission;
